import React from 'react';
import { ScheduleTimingForm } from './ScheduleTimingForm';

// Global schedule & timing card (applies to all enabled filters)
export function GlobalScheduleCard({
    globalFrequency,
    setGlobalFrequency,
    quietHoursEnabled,
    setQuietHoursEnabled,
    quietHoursSlots,
    addTimeSlot,
    removeTimeSlot,
    updateTimeSlot,
}) {
    return (
        <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
            <div className="p-6 border-b border-gray-100">
                <h2 className="text-lg font-bold text-gray-900 mb-1">
                    Schedule & Timing
                    <span className="ml-2 text-xs font-normal text-gray-400">This setting is for all the above filters</span>
                </h2>
                <p className="text-gray-500 text-sm">Configure when and how often to receive notifications</p>
            </div>
            <div className="p-6">
                <ScheduleTimingForm
                    isGlobal={true}
                    frequency={globalFrequency}
                    setFrequency={setGlobalFrequency}
                    quietHoursEnabled={quietHoursEnabled}
                    setQuietHoursEnabled={setQuietHoursEnabled}
                    slots={quietHoursSlots}
                    addSlot={addTimeSlot}
                    removeSlot={removeTimeSlot}
                    updateSlot={updateTimeSlot}
                />
            </div>
        </div>
    );
}
